import { apiSlice } from './apiSlice'

export interface JudgeAssignment {
  id: string
  judge_id: string
  case_id: string
  /** Vòng áp dụng — null = áp dụng toàn case (legacy/general). Vd. round Memorial vs round Bán kết. */
  round_id?: string | null
  team_ids: string[]
  notes?: string | null
  created_at?: string
  created_by?: string | null
}

export interface JudgeAssignmentCreate {
  judge_id: string
  case_id: string
  round_id?: string | null
  team_ids: string[]
  notes?: string | null
}

export interface AutoFromBracketRequest {
  case_id: string
  round_id: string
  judge_ids: string[]
}

export const judgeAssignmentsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getJudgeAssignments: builder.query<
      JudgeAssignment[],
      { judge_id?: string; case_id?: string; round_id?: string } | void
    >({
      query: (params) => ({
        url: '/judge-assignments/list',
        params: params || {},
      }),
      providesTags: ['JudgeAssignment'],
    }),
    createJudgeAssignment: builder.mutation<JudgeAssignment, JudgeAssignmentCreate>({
      query: (body) => ({
        url: '/judge-assignments/create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['JudgeAssignment', 'Case'],
    }),
    deleteJudgeAssignment: builder.mutation<{ message: string }, string>({
      query: (id) => ({
        url: `/judge-assignments/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['JudgeAssignment', 'Case'],
    }),
    autoAssignFromBracket: builder.mutation<JudgeAssignment[], AutoFromBracketRequest>({
      query: (body) => ({
        url: '/judge-assignments/auto-from-bracket',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['JudgeAssignment', 'Case'],
    }),
  }),
})

export const {
  useGetJudgeAssignmentsQuery,
  useCreateJudgeAssignmentMutation,
  useDeleteJudgeAssignmentMutation,
  useAutoAssignFromBracketMutation,
} = judgeAssignmentsApi
